import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Badge, Group, Text, Tooltip } from "@mantine/core"
import { formatTime } from "../../../lib/format-date"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * Compact "health heartbeat" shown during active recording. Reflects the
 * useRecordingHealthCheck hook output as a tooltip-wrapped status dot plus the
 * last-checked time.
 */
export const HealthIndicator = ({ status, label, lastChecked, issues }: IProps): React.JSX.Element | null => {
  const { i18n } = useLingui()

  if (!lastChecked) return null

  const tooltipLabel = issues.length > 0 ? issues.join(" · ") : i18n._(msg`All systems nominal`)
  const color = status === "nominal" ? "success" : status === "warning" ? "warning" : "danger" // status === "error"

  return (
    <Group gap="xs" mb="xs">
      <Tooltip label={tooltipLabel} withArrow>
        <Badge color={color} variant="dot" size="sm" className={classes.healthBadge}>
          {label}
        </Badge>
      </Tooltip>
      <Text size="xs" c="dimmed">
        checked {formatTime(i18n, lastChecked)}
      </Text>
    </Group>
  )
}
